<template>
<div>
  <TopBar/>
  <el-container>
  <el-container>
    <SideBar/>
    <el-main>
      <div class="main" style="overflow-y: hidden;;background: #e8e8e8;;display: flex;flex-direction: column;width: 100%;padding: 20px;">
            <div class="welcome" style="border-radius: 10px;height: 50px;display: flex;background: #ffffff;">
                <h3 style="margin-left: 10px;">欢迎回来，Ryan Septimus</h3>
            </div>
            <div class="second" style="display: flex;height: 60%;margin-top: 20px;width: 100%;">
                <div class="platform-dynamic" style="background: #ffffff;display: flex;flex-direction: column;width: 50%;">
                    <p style="font-weight: 600;">平台实时动态</p>
                    <PlatDynamic></PlatDynamic>
                </div>
                <div class="platform-data" style="border-radius: 10px;background: #ffffff;width: 50%;margin-left: 20px;justify-content: center;align-items: center;">
                  <p style="font-weight: 600;">平台数据总览</p>
                  <div class="data" style="display: flex;flex-direction: row;">
                    <div class="left-data" style="width: 50%;">
                      <ul>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">3,276</h1>
                          <p>课堂总数</p>
                        </li>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">2,831</h1>
                          <p>教师人数</p>
                        </li>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">328,497</h1>
                          <p>平台资源数</p>
                        </li>
                      </ul>
                    </div>
                    <div class="bar" style="border: 1px solid;margin-bottom: 20px;">

                    </div>
                    <div class="right-data" style="width: 50%;">
                      <ul>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">13,115</h1>
                          <p>课堂总数</p>
                        </li>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">32,186</h1>
                          <p>教师人数</p>
                        </li>
                        <li>
                          <h1 style="font-weight: 700;color: #21ccff;">17,154</h1>
                          <p>平台资源数</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
            <div class="bottom" style="display: flex;height: auto;margin-top: 20px;width: 100%;">
                <div class="platform-user" style="background: #ffffff;width: 70%;height: inherit;">
                  <p style="font-weight: 600;">平台使用情况（近七日）</p>
                  <PlatUseVue></PlatUseVue>
                </div>
                <div class="plat-resource" style="background: #ffffff;width: 30%;margin-left: 20px;">
                  <p style="font-weight: 600;">平台资源总览</p>
                  <div class="resource"  style="display: flex;align-items: center;justify-content: start;">
                    <div class="left-resource" style="width: 50%;">
                      <ul>
                        <li>
                          <img src="../../public/images/文档color.png" alt="文档">
                          <div class="resource-text" style="">
                            <p>文档 8.5GB</p>
                            <p>76692</p>
                          </div>
                        </li>
                        <li>
                          <img src="../../public/images/笔记蓝.png" alt="笔记">
                          <div class="resource-text">
                            <p>笔记 892MB</p>
                              <p>162</p>
                          </div>
                        </li>
                    
                        <li>
                          <img src="../../public/images/讨论蓝.png" alt="讨论">
                          <div class="resource-text">
                            <p>讨论</p>
                            <p>742</p>
                          </div>
                        </li>
                        <li>
                          <img src="../../public/images/作业中心蓝.png" alt="作业">
                          <div class="resource-text">
                            <p>作业/测验</p>
                            <p>1535</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="right-resource">
                      <ul>
                        <li>
                          <img src="../../public/images/图片蓝.png" alt="图片">
                          <div class="resource-text">
                            <p>图片 13.2GB</p>
                            <p>19356</p>
                          </div>
                        </li>
                        <li>
                          <img src="../../public/images/视频蓝.png" alt="视频">
                          <div class="resource-text">
                            <p>视频 10.2GB</p>
                            <p>146</p>
                          </div>
                        </li>
                        <li>
                          <img src="../../public/images/思维导图蓝.png" alt="导图">
                          <div class="resource-text" >
                            <p>导图</p>
                            <p>138</p>
                          </div>
                        </li>
                        <li>
                          <img src="../../public/images/其他蓝.png" alt="其它">
                          <div class="resource-text" >
                            <p>其它</p>
                            <p>122,917</p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </el-main>
  </el-container>
</el-container>
  

</div>

</template>
<script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';
import PlatUseVue from '@/components/PlatUse.vue';
import PlatDynamic from '../components/PlatDynamic.vue';
export default {
  name: 'HomePage',
  components: {
    SideBar,
    TopBar,
    PlatDynamic,
    PlatUseVue
  }
}
</script><style scoped>
.resource ul > li {
  margin: 0px;
  margin-right: 0;
  flex-direction: row; /* 子元素水平排列 */
  height: 100px;
  width: 90%;
  display: flex;
}

.resource ul > li > img {
  margin: 5px;
  height: 70px; /* 这里应该是100%，以填满容器 */
  width: 70px;  /* 这里应该是100%，以填满容器 */
  object-fit: cover; /* 'cover'属性是object-fit的值 */
}
.resource-text{
  font-size: 17px;
  display: flex;
  flex-direction: column;
  width: 200px;
}
ul>li{

}
</style>